import React, { useContext } from 'react'

import MicrocopyContext from '~contexts/MicrocopyContext'
import List from './List'

import style from './References.module.scss'

const References = ({
  title,
  centeredTitle,
  tags = [],
  resources = [],
  showAll = false
}) => {
  const microcopy = useContext(MicrocopyContext)

  resources = chunk(resources, 10).map((chunk, index) => ({
    name: index === 0 ? microcopy.text('reference.titles.other_resources') : null,
    resources: chunk
  }))

  return (
    <div>
      { title && <h1 className={style.title} data-centered={centeredTitle}>
          <span>{ title }</span>
        </h1>
      }
      <div className={style.grid} data-wid data-show-all={showAll}>
        { tags.filter(notEmpty).map((tag) => <List key={tag.id} list={tag} /> )}
        { resources.map((chunk, index) => <List key={index} list={chunk} /> )}
      </div>
    </div>
  )
}

// Chunk an array into multiple arrays of the same size
const chunk = (array, chunkSize) => {
  let myArray = [ ...array ]
  let results = []
  while (myArray.length) { results.push(myArray.splice(0, chunkSize)) }
  return results
}

const notEmpty = tag => tag.resources?.[0] || tag.endpoints?.[0]

export default References